import { useEffect, useState } from 'react';

const getViewportWidth = () => {
  if (typeof window === 'undefined') return 1024;
  return window.innerWidth || document.documentElement?.clientWidth || 1024;
};

/**
 * 断点 Hook：主门户在手机走移动首页/底部导航，平板走抽屉侧栏，桌面固定侧栏。
 */
export function useBreakpoint() {
  const [width, setWidth] = useState(getViewportWidth);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    let frameId = null;
    const updateWidth = () => {
      if (frameId) window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(() => {
        frameId = null;
        setWidth(getViewportWidth());
      });
    };

    window.addEventListener('resize', updateWidth);
    window.addEventListener('orientationchange', updateWidth);
    return () => {
      if (frameId) window.cancelAnimationFrame(frameId);
      window.removeEventListener('resize', updateWidth);
      window.removeEventListener('orientationchange', updateWidth);
    };
  }, []);

  const isMobile = width < 768;
  const isTablet = width >= 768 && width < 1024;

  return {
    device: isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop',
    width,
    isMobile,
    isTablet,
    isDesktop: width >= 1024,
    sidebarAsDrawer: width < 1024,
  };
}

export default useBreakpoint;
